import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { message } from "antd";
import { MAIN_ROUTES, APP_ROUTES } from '../../../_config/routes';
import { useQuery } from '../../../_utils/url_query_hook';
import { ROLES } from "../../../_config/roles";
import RolWrapper from "../../hoc/roles_wrapper";
import { findEanByClientEvent } from "../../../_events/ean/find.event";
import { FormControl } from "@mui/material";
import { findAllColors } from "../../../_events/color/find_colors.event";
import AutoSelect from "../../../containers/selects/auto_select";
import { findProductsAllEvent } from "../../../_events/products/findProducts.event";
import { createEanEvent, editEanEvent } from "../../../_events/ean/create.event";
import { specialEanClients } from "../../../_config/special-ean-clients";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin]);

const Ean = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'product.ref', headerName: 'Referencia', width: 200,
        valueGetter: (params) => params.row.product ? params.row.product.ref : '',
            renderCell: (params) => {  
                return <span>{params.row.product ? params.row.product.ref : ''}</span>;
            }
        },
        { field: 'color.cod', headerName: 'Color', width: 200,
        valueGetter: (params) => params.row.color ? params.row.color.cod : '',
            renderCell: (params) => {  
                return <span>{params.row.color ? params.row.color.cod : ''}</span>;
            }
        },
        { field: 'serial', headerName: 'Serial', width: 200,
        
        },
        { field: '', headerName: 'Acciones', width: 100, sortable: false, filterable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem({
                        uuid: params.row.uuid,
                        client: params.row.client?.uuid,
                        product: params.row.product?.uuid,
                        color: params.row.color?.uuid,
                        serial: params.row.serial,
                        clientproduct: params.row.clientproduct,
                        clientcolor: params.row.clientcolor,
                    }); setRender('form');
                };    
                return <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>;
            }
        },
    ];

    const additionalColumns = [
        { field: 'clientproduct', headerName: 'Referencia cliente', width: 200,},
        { field: 'clientcolor', headerName: 'Color cliente', width: 200,},
    ];

    let query = useQuery();

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <div style={{display: 'flex', flexDirection: 'row', width:'60%'}}>
                    <Typography variant="h6" component="h6">
                        Clientes - Configuración de EAN
                    </Typography>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'40%'}}>
                        {
                            render === 'info' ? 
                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <Link style={{ margin: '0 10px' }} to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.clients}`}>
                                    <Button variant="contained">Volver a clientes</Button>
                                </Link>
                                <ButtonRolAuthComponent 
                                    variant='contained'
                                    onClick={() => {
                                        setItem({
                                            client: query.get("c"),
                                            product: '',
                                            color: '',
                                            serial: ''
                                        }); 
                                        setRender('form');
                                    }}
                                >
                                    Crear
                                </ButtonRolAuthComponent>
                            </div>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                {
                    render === 'info' ? <Info columns={columns} additionalColumns={additionalColumns} clientId={query.get("c")} clientCod={query.get("cod")} /> : <Form clientCod={query.get("cod")} item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const Info = (props) => {

    const [data, setData] = useState([]);

    const findData = () => {
        findEanByClientEvent(props.clientId)
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findData();
    }, []);

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={data}
                columns={specialEanClients.includes(props.clientCod) ? props.additionalColumns.concat(props.columns) : props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

const Form = (props) => {
    const [ean, setEan] = useState(props.item);
    const isSpecialEan = useRef(specialEanClients.includes(props.clientCod))
    const edit = () => {
        editEanEvent(ean.uuid, ean)
        .then(data => {
            message.success('Ean actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const create = () => {
        createEanEvent(ean)
        .then(data => {
            message.success('Ean actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <FormControl size="small" fullWidth>
                        <AutoSelectProduct
                            ean={ean}
                            setEan={setEan}
                        />
                    </FormControl>   
                </Grid>
                {
                    isSpecialEan.current && 
                    <Grid item xs={12} md={12}>
                        <TextField 
                            style={{width: '100%'}} 
                            id="clientproduct" 
                            label="Referencia del producto del cliente" 
                            variant="outlined"
                            size="small"
                            type="text"
                            value={ ean? ean.clientproduct : '' }
                            onChange={(e) => {
                                let newEnt = {...ean};
                                newEnt.clientproduct = e.target.value;
                                setEan(newEnt);
                            }}
                        />        
                    </Grid>
                }
                <Grid item xs={12} md={12}>
                    <FormControl size="small" fullWidth>
                        <AutoSelectColors
                            ean={ean}
                            setEan={setEan}
                        />
                    </FormControl>
                </Grid>
                {
                    isSpecialEan.current && 
                    <Grid item xs={12} md={12}>
                        <TextField 
                            style={{width: '100%'}} 
                            id="clientcolor" 
                            label="Código de color del cliente" 
                            variant="outlined"
                            size="small"
                            type="text"
                            value={ ean? ean.clientcolor : '' }
                            onChange={(e) => {
                                let newEnt = {...ean};
                                newEnt.clientcolor = e.target.value;
                                setEan(newEnt);
                            }}
                        />        
                    </Grid>
                }
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="serail" 
                        label="Serial" 
                        variant="outlined"
                        size="small"
                        type="text"
                        value={ ean? ean.serial : '' }
                        onChange={(e) => {
                            let newEnt = {...ean};
                            newEnt.serial = e.target.value;
                            setEan(newEnt);
                        }}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        ean.uuid
                        ?
                        <Button style={{width: '100%'}} onClick={() => edit()} variant="contained">Editar</Button>
                        :
                        <Button style={{width: '100%'}} onClick={() => create()} variant="contained">Crear</Button>
                    }
                </Grid>              
            </Grid>
        </div>
    );
}

export default Ean;

const AutoSelectColors = ({ ean, setEan }) => {

    const [colors, setColors] = useState([]);

    useEffect(() => {
        findAllColors()
        .then(data => {
            setColors(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }, []);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <AutoSelect
                    id='order_color_autoselect'
                    label='Color'
                    getOptionLabel={(option) => `${option.cod}`}
                    renderOption={(props, option) => (<div {...props}>{`${option.cod}`}</div>)}
                    data={colors}
                    onChange = {(value) => {
                        let newEnt = {...ean};
                        newEnt.color = value.uuid;
                        setEan(newEnt);
                    }}
                />
            </Grid>
        </Grid>
    );

}

const AutoSelectProduct = ({ ean, setEan }) => {

    const [ products, setProducts ] = useState([]);

    useEffect(() => {
        findProductsAllEvent()
        .then(json => {
            setProducts(json.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }, []);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <AutoSelect
                    id='order_product_autoselect'
                    label='Producto'
                    getOptionLabel={(option) => `${option ? option.ref : ''}`}
                    renderOption={(props, option) => {
                        if(option){
                            return(<div {...props}>{`${option?.ref}`}</div>);
                        }
                    }}
                    data={products}
                    onChange={(value) => {
                        let newEnt = {...ean};
                        newEnt.product = value.uuid;
                        setEan(newEnt);
                    }}
                />
            </Grid>
        </Grid>
    );

}